import {useCallback} from 'react';
import AnalyticsService, {
  eventNames,
} from '@/services/analytics/AnalyticsService';

export interface ViewDismissedEventParams {
  presentation_id: string;
  interaction_id: string;
  flow_name?: string;
  reason: string;
  view_details?: string;
}

function useViewDismissedEvent() {
  const viewDismissed = useCallback(
    ({
      presentation_id,
      interaction_id,
      flow_name = '',
      reason,
      view_details = '',
    }: ViewDismissedEventParams) => {
      const flow = flow_name ? AnalyticsService.getFlow(flow_name) : undefined;
      AnalyticsService.dispatchEvent(eventNames.CONTENT_STUDIO_VIEW_DISMISSED, {
        presentation_id,
        interaction_id,
        flow_id: flow?.flow_id || '',
        reason,
        view_details,
      });
    },
    []
  );

  return {viewDismissed};
}

export default useViewDismissedEvent;
